import dynamic from "next/dynamic";

export const DynamicVideo = dynamic(
  () => import("@/components/landing/Video").then(m => m.Video),
  {
    ssr: false,
    loading: () => (
      <section className="z-40 relative mt-10 lg:mt-[10em] container flex flex-col items-center justify-center">
        <div className="border border-text-foreground/30 rounded-md overflow-clip max-w-[800px] w-full relative">
          <img
            src="/video3.png"
            alt="Self-hosting Next.js with Dollar Deploy"
            width={1920}
            height={1080}
            className="w-full block rounded-md shadow-lg"
          />
        </div>
      </section>
    )
  }
);
